export const SalePaymentStatus = [
  {
    Id: 1,
    Name: 'SALE_PAYMENT_STATUS.CHARGED',
  },
  {
    Id: 2,
    Name: 'SALE_PAYMENT_STATUS.DONE',
  },
]
